import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import withStyles from '@mui/styles/withStyles';
import PageTitle from '../ui/PageTitle';
import { Grid, Paper, Typography } from '@mui/material';

import ServerError from '../ui/ServerError';
import AbEnvironment from '../auth/AbEnvironment';

import Form from './Form';
import LoadingSpinner from '../ui/LoadingSpinner';

const styleSheet = theme => ({
  root: {
    width: '100%',
  },
  rootLoggedIn: {
    flexGrow: 1,
    //padding: 20,
  },
  paper: {
    textAlign: 'left',
    //color: theme.palette.text.secondary,
    maxWidth: 980,
    marginTop: 32,
    marginBottom: 0,
    paddingTop: 16,
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 20,
  }
});

const abEnvironment = new AbEnvironment();

const VendorProgramFormQuery = graphql`
query VendorProgramFormQuery($formId: UUID!, $accountId: UUID!) {
  accountTByAccountId(accountId: $accountId) {
    accountName
  }
  formTByFormId(formId: $formId) {
    formName
    formTitle
    formSubtitle
    description
    vppTsByFormId {
      nodes {
        description
        programName
        visibility
        vppRTsByVppId (condition: {partnerId: $accountId}) {
          totalCount
          nodes {
            stage
          }
        }
      }
    }
    formDetailTsByFormId (orderBy: Q_ORDER_ASC) {
      totalCount
      nodes {
        key: qKey
        name: qName
        type: qType
        default: qDefault
        optional: qOptional
        qWidth
        formDetailValuesTsByFormDetailId (orderBy: DISPLAY_ORDER_ASC) {
          totalCount
          values: nodes {
            value: displayOrder
            text 
          }
        }
      }
    }
    formResponseTsByFormId (condition: {accountId : $accountId}) {
      totalCount
      nodes {
        accountId
        qKey
        qResponse
      }
    }
  }
}
`;

class VendorProgramForm extends Component {

  constructor(props) {
    super(props);

    this.state = {
      saveStatus: null,
      saveFormMessage: '',
      fieldErrors: {},
      values: null,
      valuesLastSaved: null,
    }
  }

  //this has to be wrong, very hacky... someone could rewrite this state reference..
  componentDidMount() {
    if (this.props.passSaveFunction) {
      this.props.passSaveFunction(this.saveForm);
    }
  }

  saveForm = () => {
    //putting "values" into state, this is a way of checking against changes from contained "form"
    let values = this.state.values;
    this.setState({
      valuesLastSaved: values
    });

    //transforming values into array with objects having "qKey" and "qResponse" properties
    let formResponses = Object.keys(values).map(key => ({"qKey": key, "qResponse": String(values[key])}));

    let responseSavePromise = Promise.resolve()
    .then(() => {
      const { callPartnerApi } = this.props.auth;
      
      let payload = {
        operation: "saveFormResponses",
        params: {
          accountId: this.accountId,
          formId: this.formId,
          apps: formResponses
        }
      };

      return callPartnerApi('appbind/generic',
                            'POST',
                            payload);
    }).then((response) => {
      // console.log("executed query success?: " + JSON.stringify(response));
      this.setState({
        saveStatus: 'success',
        saveFormMessage: 'Form saved.',
      });
    }).catch(err => {
      console.log("Error: " + err.message);
      this.setState({
        saveStatus: 'error',
        saveFormMessage: 'Unable to save form. Try again later.',
      });
    });

    return responseSavePromise;
  };

  //lift "values" state here from the form.
  handleChange(values) {
    this.setState({
      values: values
    });
    // console.log('formstate: ' + JSON.stringify(values) + '\ntopstate: ' + JSON.stringify(this.state.values) + '\nlastsaved: ' + this.state.valuesLastSaved);
  }

  render() {
    const classes = this.props.classes;
    const { isAuthenticated, needAssent, isAuthenticatedReseller, isAuthenticatedVendor, logError, isAuthenticatedAppBind } = this.props.auth;

    if (!isAuthenticated() || needAssent()) {
      return (<Redirect to='/home' />);
    } else if (isAuthenticatedReseller() || isAuthenticatedVendor() || isAuthenticatedAppBind()) {
      
      let componentView = false;

      let formId;
      if (this.props.formId) {
        //if this is a props view, load the values that way instead.
        formId = this.props.formId
        componentView = true;
      } else {
        //grab parameters for use in query renderer...
        const params = new URLSearchParams(this.props.location.search);
        formId = params.get('formId');
      }
      
      //using query renderer within the return segment...
      if (!formId) {
        return (<Redirect to='/home' />);
      }
      
      //accountId field is "the partner"; null if vendor and not looking for partner info.
      let accountId = null;
      if (this.props.accountId) {
        accountId = this.props.accountId;
      } else if (isAuthenticatedReseller()) {
        //if reseller and no accountId supplied, need to get from auth.
        accountId = abEnvironment.getUserAttribute("a_id");
      } else {
        const params = new URLSearchParams(this.props.location.search);
        accountId = params.get('accountId');
      }

      this.accountId = accountId;
      this.formId = formId;

      return (
        <div classes={classes.rootLoggedIn}>
          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={VendorProgramFormQuery}
            variables={{
              formId: formId,
              accountId: accountId,
            }}
            render={({error, props})=> {
              if (error) {
                //if there was a null accountId, we know the problem
                if (isAuthenticatedVendor() &&  accountId === null) {
                  return(
                    <div className={classes.root} style={{maxWidth: 900}}>
                      <PageTitle title="Must specify partner account" showBackButton={true} history={this.props.history}/>
                    </div>
                  );
                }
                
                logError(JSON.stringify(error));
                return (
                  <ServerError />
                );
              } else if (props) {
                // if nothing is returned, then there's no access right OR the form doesn't exist
                if (props.formTByFormId === null) {
                  return (
                    <div className={classes.root} style={{maxWidth: 900}}>
                      <PageTitle title="Form not found" showBackButton={true} history={this.props.history}/>
                    </div>
                  );
                }

                let form = props.formTByFormId;

                let fieldsFromDB = form.formDetailTsByFormId.nodes;
                let responseValuesFromDB = form.formResponseTsByFormId.nodes;
                
                let values = {};
                //add the default values from each field here if no form response entries.
                if (form.formResponseTsByFormId.totalCount <= 0) {
                  for (let i = 0; i < fieldsFromDB.length; i++) {
                    let currentField = fieldsFromDB[i];
                    if (currentField.default) {
                      values[currentField.key] = currentField.default
                    }
                  }
                }

                //overwrite the defaults with saved response, if that response exists.
                for (let i = 0; i < responseValuesFromDB.length; i++) {
                  values[responseValuesFromDB[i].qKey] = responseValuesFromDB[i].qResponse;
                }

                // Get the form title and subtitle
                let formTitle = form.formTitle;
                let formSubtitle = form.formSubtitle;

                //use the stage to conditionally display certain things (this might be overriden by the vpp_r page)
                let partnerProgram = form.vppTsByFormId.nodes[0];
                let resellerAccountStage = null;
                if (accountId) {
                  let vppResellers = partnerProgram.vppRTsByVppId.nodes;
                  resellerAccountStage = vppResellers.length > 0 ? vppResellers[0].stage : null;
                }

                //"what to display if the reseller is in different states:"
                // these stages are probably a part of the progression later.
                let resellerStageText = '';
                switch (resellerAccountStage) {
                  case 1: //pending (applied)
                    resellerStageText = 'The form has been submitted';
                    break;
                  case 2: //active
                    resellerStageText = 'You have been accepted into ' + partnerProgram.programName;
                    break;
                  case 3: //suspended
                    resellerStageText = 'Your partner program status is suspended';
                    break;
                  case 4: //rejected
                    resellerStageText = 'Your previous application for this program has been rejected';
                    break;
                  case 5: //left
                    resellerStageText = 'You left this partner program; re-apply if you wish to be considered again';
                    break;
                  default:
                    resellerStageText = '';
                    break;
                }

                //should be constant on render; displayOnly mode if in vendor view or is reseller further into approval process.
                let displayOnly = isAuthenticatedVendor() || (isAuthenticatedReseller() && resellerAccountStage >= 1);

                //the form
                let theFormRender = <Form
                                      onChange={(values) => {this.handleChange(values)}}
                                      values={this.state.values || values}
                                      lastValues={this.state.valuesLastSaved || values}
                                      fields={fieldsFromDB}
                                      saveStatus={this.state.saveStatus}
                                      saveFormMessage={this.state.saveFormMessage}
                                      snackbarClose={() => { this.setState({ saveStatus: '', saveFormMessage: '' }); }}
                                      saveForm={!displayOnly && this.saveForm}
                                      errors={this.state.fieldErrors}
                                      setFormSaveDisabled={this.props.setFormSaveDisabled}
                                      isDialog={this.props.passSaveFunction !== undefined}
                                    />;

                return (
                  <Grid container spacing={1}>
                    { !componentView &&
                      <Grid item xs={12}>
                        <PageTitle title={formTitle} subtitle={formSubtitle} />
                        <Paper className={classes.paper}>
                          { isAuthenticatedVendor() &&
                            <Typography variant='h5'>This is a view-only form for {props.accountTByAccountId.accountName}</Typography>
                          }
                          { isAuthenticatedReseller() && resellerAccountStage > 0 && 
                            <Typography variant='h5'>{resellerStageText}</Typography>
                          }
                          { theFormRender }
                        </Paper>
                      </Grid>
                    }
                    { componentView &&
                      <Grid item xs={12}>
                        { isAuthenticatedVendor() && 
                        <Typography variant='h6'>Application</Typography>}
                        { !isAuthenticatedVendor() &&
                        <PageTitle title={formTitle} subtitle={formSubtitle} />}
                        {/*<Typography variant='body2'>{formSubtitle}</Typography>}*/}
                        { theFormRender }
                      </Grid>
                    }
                  </Grid>
                )
              }
              return <LoadingSpinner />
            }}
          />
          
        </div>
      );
    } else {
      return (<Redirect to='/home' />);
    }
  }

}

export default withStyles(styleSheet)(VendorProgramForm);